import {
  Stack,
  Box,
  Typography,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ApplePayIcon from "src/assets/svg-icons/apple-pay.svg";
import VisaCreditIcon from "src/assets/svg-icons/visa-credit.svg";
import AmexIcon from "src/assets/svg-icons/amex.svg";
import { FormData } from "../../constants";
import ApplePayButton from "src/shared/components/apple-pay-button";
import { useEffect, useState } from "react";
import sarIcon from "src/assets/svg-icons/sar.svg";

const PaymentType = ({
  price,
  mutatePay,
  setApplePaySession,
  isPartialPaid = false,
  amexDiscountValue,
  isOnlinePaymentsEnabled,
  hasGlobalDiscount,
  globalDiscountPer,
}: {
  price: number;
  mutatePay: Function;
  setApplePaySession: any;
  isPartialPaid: boolean;
  amexDiscountValue: number;
  isOnlinePaymentsEnabled: boolean;
  hasGlobalDiscount: boolean;
  globalDiscountPer: number;
}) => {
  const { t, i18n } = useTranslation();
  const [canPayWithApplePayment, setCanPayWithApplePayment] = useState(false);

  useEffect(() => {
    const merchantId = process.env.APPLE_PAY_MERCHANT_ID;
    console.log({ merchantId });
    const windowCopy: any = window;
    console.log("browser supports apple pay:", !!windowCopy?.ApplePaySession);

    if (windowCopy?.ApplePaySession) {
      setCanPayWithApplePayment(true);
      //TODO: next condition now has no value
      const promise = windowCopy.ApplePaySession.canMakePaymentsWithActiveCard(
        process.env.APPLE_PAY_MERCHANT_ID
      );
      console.log({ promise });
      promise.then(function (canMakePayments: boolean) {
        console.log("Merchant can receive apple pay:", { canMakePayments });
        if (canMakePayments) {
          setCanPayWithApplePayment(true);
        }
      });
    }
  }, []);

  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext<FormData>();

  console.log({ canPayWithApplePayment });

  return (
    <Stack mt={4} alignItems={"center"}>
      <Box
        display={"inline-block"}
        bgcolor={"#333536"}
        color={"#BBBBBB"}
        padding={"4px 10px"}
        borderRadius={"6px"}
      >
        <Typography>{t("yourFeesIs")}</Typography>
      </Box>
      <Stack my={1} direction={"row"} alignItems={"center"} gap={"4px"}>
        <Stack
          direction={i18n.language === "en" ? "row" : "row-reverse"}
          alignItems={"center"}
          gap={"4px"}
        >
          <img height={32} src={sarIcon} alt="" />
          <Typography fontSize={"47px"} fontWeight={700}>
            {price}
          </Typography>
        </Stack>
        {/* {hasGlobalDiscount && (
          <Typography
            color={"#4EBE86"}
            fontSize={"16px"}
            fontWeight={600}
            component={"span"}
          >
            ( %{globalDiscountPer} {t("discountApplied")} )
          </Typography>
        )} */}
      </Stack>
      <FormControl fullWidth error={!!errors.paymentType}>
        <Controller
          name="paymentType"
          control={control}
          render={({ field }) => (
            <RadioGroup
              {...field}
              key={field.value}
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
              sx={{ gap: 2 }}
            >
              {isOnlinePaymentsEnabled ? (
                <>
                  {/* credit or debit card */}
                  <Stack borderBottom={"1px solid #5F5C5C"} pb={2}>
                    <Stack
                      direction={"row"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <FormControlLabel
                        value="card"
                        control={<Radio />}
                        label={t("creditDebitCard")}
                      />
                      <img src={VisaCreditIcon} alt="" />
                    </Stack>

                    {watch("paymentType") === "card" && (
                      <Stack gap={2}>
                        <Box
                          p={"10px"}
                          bgcolor={"#151515"}
                          borderRadius={"12px"}
                        >
                          <Typography fontSize={"9px"}>
                            {t("paySecurelyWithVisaOrMastercard")}
                          </Typography>
                        </Box>
                        <Controller
                          name="name"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              label={t("cardholderName")}
                              {...field}
                              error={!!errors.name}
                              helperText={t(`${errors.name?.message ?? ""}`)}
                              fullWidth
                              size="small"
                              variant="outlined"
                            />
                          )}
                        />
                        <Controller
                          name="cardNumber"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              label={t("cardNumber")}
                              {...field}
                              error={!!errors.cardNumber}
                              helperText={t(
                                `${errors.cardNumber?.message ?? ""}`
                              )}
                              fullWidth
                              size="small"
                              variant="outlined"
                            />
                          )}
                        />
                        <Stack direction={"row"} gap={2}>
                          <Controller
                            name="expiry_at"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <TextField
                                label={t("expiryDate")}
                                placeholder="MM/YY"
                                // {...field}
                                value={value}
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (
                                    inputValue.length === 2 &&
                                    Number(watch("expiry_at")?.length) < 2 && // to enable deleting
                                    !inputValue.includes("/")
                                  ) {
                                    // Automatically add '/' after entering 2 digits (month)
                                    onChange(inputValue + "/");
                                  } else {
                                    onChange(inputValue);
                                  }
                                }}
                                error={!!errors.expiry_at}
                                helperText={t(
                                  `${errors.expiry_at?.message ?? ""}`
                                )}
                                fullWidth
                                size="small"
                                variant="outlined"
                                inputProps={{
                                  maxLength: 5, // Limit input to 5 characters (MM/YY format)
                                }}
                              />
                            )}
                          />
                          <Controller
                            name="cvv"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                label={t("CVV")}
                                {...field}
                                error={!!errors.cvv}
                                helperText={t(`${errors.cvv?.message ?? ""}`)}
                                fullWidth
                                size="small"
                                variant="outlined"
                              />
                            )}
                          />
                        </Stack>
                      </Stack>
                    )}
                  </Stack>

                  {/* apple pay */}
                  {canPayWithApplePayment && (
                    <Stack borderBottom={"1px solid #5F5C5C"} pb={2}>
                      <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        <FormControlLabel
                          value="applepay"
                          control={<Radio />}
                          label={t("applePay")}
                        />
                        <img src={ApplePayIcon} alt="" />
                      </Stack>

                      {watch("paymentType") === "applepay" && (
                        <Box
                          display={"flex"}
                          justifyContent={"center"}
                          mt={0.5}
                        >
                          <ApplePayButton
                            amount={price}
                            mutatePay={mutatePay}
                            setApplePaySession={setApplePaySession}
                          />
                        </Box>
                      )}
                    </Stack>
                  )}

                  {/* <Stack borderBottom={"1px solid #5F5C5C"} pb={2}>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <FormControlLabel
                    value="googlepay"
                    control={<Radio />}
                    label={t("googlePay")}
                  />
                  <img height={35} src={GooglePayIcon} alt="" />
                </Stack>

                {watch("paymentType") === "googlepay" && (
                  <Box display={"flex"} justifyContent={"center"} mt={1}>
                    <CustomGooglePayButton
                      amount={price}
                      mutatePay={mutatePay}
                    />
                  </Box>
                )}
              </Stack> */}

                  {/* amex */}
                  <Stack borderBottom={"1px solid #5F5C5C"} pb={2}>
                    <Stack
                      direction={"row"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Stack direction={"row"} alignItems={"center"}>
                        <FormControlLabel
                          value="amex"
                          control={<Radio />}
                          label={t("amex")}
                        />
                        {amexDiscountValue > 0 ? (
                          <Box
                            borderRadius={"20px"}
                            bgcolor={"#CC9C3333"}
                            padding={"4px 11px"}
                            border={"1px solid #D4AD53"}
                          >
                            <Typography color={"primary"} fontSize={"13px"}>
                              % {amexDiscountValue} Discount
                            </Typography>
                          </Box>
                        ) : null}
                      </Stack>

                      <img src={AmexIcon} alt="" />
                    </Stack>

                    {watch("paymentType") === "amex" && (
                      <Stack gap={2} pt={1}>
                        <Controller
                          name="amexName"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              label={t("cardholderName")}
                              {...field}
                              error={!!errors.amexName}
                              helperText={t(
                                `${errors.amexName?.message ?? ""}`
                              )}
                              fullWidth
                              size="small"
                              variant="outlined"
                            />
                          )}
                        />
                        <Controller
                          name="amexCardNumber"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              label={t("cardNumber")}
                              {...field}
                              error={!!errors.amexCardNumber}
                              helperText={t(
                                `${errors.amexCardNumber?.message ?? ""}`
                              )}
                              fullWidth
                              size="small"
                              variant="outlined"
                            />
                          )}
                        />
                        <Stack direction={"row"} gap={2}>
                          <Controller
                            name="amexExpiryAt"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <TextField
                                label={t("expiryDate")}
                                placeholder="MM/YY"
                                // {...field}
                                value={value}
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (
                                    inputValue.length === 2 &&
                                    Number(watch("amexExpiryAt")?.length) < 2 && // to enable deleting
                                    !inputValue.includes("/")
                                  ) {
                                    // Automatically add '/' after entering 2 digits (month)
                                    onChange(inputValue + "/");
                                  } else {
                                    onChange(inputValue);
                                  }
                                }}
                                error={!!errors.amexExpiryAt}
                                helperText={t(
                                  `${errors.amexExpiryAt?.message ?? ""}`
                                )}
                                fullWidth
                                size="small"
                                variant="outlined"
                                inputProps={{
                                  maxLength: 5, // Limit input to 5 characters (MM/YY format)
                                }}
                              />
                            )}
                          />
                          <Controller
                            name="amexCvv"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                label={t("CVV")}
                                {...field}
                                error={!!errors.amexCvv}
                                helperText={t(
                                  `${errors.amexCvv?.message ?? ""}`
                                )}
                                fullWidth
                                size="small"
                                variant="outlined"
                              />
                            )}
                          />
                        </Stack>
                      </Stack>
                    )}
                  </Stack>
                </>
              ) : null}

              {!isPartialPaid && (
                <FormControlLabel
                  value="cashier"
                  control={<Radio />}
                  label={t("atTheCashier")}
                />
              )}
            </RadioGroup>
          )}
        />
      </FormControl>
    </Stack>
  );
};

export default PaymentType;
